// Module
var code = `<h1>GenAI</h1> <h3 class="metric-meaning">What does it mean?</h3><p>The traffic sent from AI assistants and chatbots, such as ChatGPT, Perplexity, Gemini, etc.</p> `;
// Exports
module.exports = code;